import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
    selector: 'app-link-input',
    templateUrl: './link-input.component.html',
    styleUrls: ['./link-input.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi: true,
            useExisting: forwardRef(() => LinkInputComponent),
        },
    ],
    standalone: false
})
export class LinkInputComponent implements ControlValueAccessor {
  @Input() label!: string;

  @Input() value!: string;

  public isFocused: boolean = false;

  public validUrl: boolean = false;

  public openLink(): void {
    window.open(this.value, '_blank');
  }

  public onChange($event: any) {
    //if is a valid url
    this.setValues($event);
  }

  // Function that will be fired when the value of the
  // input is changed.
  public inputWasChanged: any = (_: any) => _;

  private setValues($event: any) {
    if ($event.match(/^(ftp|http|https):\/\/[^ "]+$/)) {
      this.inputWasChanged($event);
      this.inputWastouched($event);
      this.validUrl = true;
    } else {
      this.validUrl = false;
    }
  }

  // Angular function for registering a change to the
  // input value
  public registerOnChange(changeFn: any): void {
    this.inputWasChanged = changeFn;
  }

  // Function that will be fired when the input has
  // been interacted with.
  public inputWastouched: any = (_: any) => _;

  // Angular function for registering an interaction
  // with the input
  public registerOnTouched(touchFn: any): void {
    this.inputWastouched = touchFn;
  }

  public writeValue(value: any): void {
    // If the value given is undefined, set it
    // to null to avoid having weird values show
    // up in the input
    if (value === undefined || value === void 0) value = null;

    // this.videoThumbPreview = this.getThumb(value);
    if (value) {
      this.value = value;
      this.isFocused = true;
      this.setValues(value);
    }
  }
}
